import { Result } from 'antd'
import React from 'react'

export default function MessagePage(props) {
    return <div style={{
        position: "relative",
        height: "calc(100vh - 250px)",
        backgroundColor: "#f5f5f5"
    }}><div className="shadow-lg" style={{
        position: "absolute",
        width: 500,
        maxWidth: "100%",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        background: "white",
        borderRadius: "8px",
        flexGrow: "1",
    }}><Result {...props}/>
    </div></div>
}
